'use client';

import React, { useState } from 'react';
import { DetailsTab } from '@/app/dashboard/tech-support/cf-accounts/components/details-tab';
import { JSONTab } from '@/app/dashboard/tech-support/domains/components/json-tab';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getUi, hideDrawerState } from '@/store/reducers/ui-slice';
import { Divider, Tab, Tabs } from '@mui/material';
import { Stack } from '@mui/system';

import { CfAccountDetailsTab, GeneralDrawer } from '@/types/general';

import DrawerTemplate from '../core/drawer-template';

export default function CfAccountDetailsDrawer(): React.JSX.Element {
  const { drawerState } = useAppSelector(getUi);
  const dispatch = useAppDispatch();

  const [tabValue, setTabValue] = useState(CfAccountDetailsTab.DETAILS);
  const tabList = [
    {
      id: CfAccountDetailsTab.DETAILS,
      label: 'Details',
      content: <DetailsTab />,
    },
    {
      id: CfAccountDetailsTab.DOMAINS,
      label: 'Domains',
      content: <DetailsTab />,
    },
    {
      id: CfAccountDetailsTab.JSON,
      label: 'JSON',
      content: <JSONTab />,
    },
  ];

  const handleChange = (event: React.SyntheticEvent, newValue: CfAccountDetailsTab): void => {
    setTabValue(newValue);
  };

  return (
    <DrawerTemplate
      open={drawerState.CF_ACCOUNT_DETAILS}
      onClose={() => dispatch(hideDrawerState(GeneralDrawer.CF_ACCOUNT_DETAILS))}
      title="CF Account Details"
      width="700px"
    >
      <Tabs value={tabValue} onChange={handleChange}>
        {tabList.map((item) => (
          <Tab key={item.id} label={item.label} value={item.id} />
        ))}
      </Tabs>
      <Divider />
      {tabList.map((item) => (
        <Stack sx={{ pt: 2, display: item.id === tabValue ? 'flex' : 'none' }} key={item.id}>
          {item.content}
        </Stack>
      ))}
    </DrawerTemplate>
  );
}
